import { registerLocaleData } from '@angular/common';
import localeEsAr from '@angular/common/locales/es-AR';
import { Component, Injector, OnDestroy, OnInit, ViewChild, effect, runInInjectionContext } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { MobileAccessibility } from '@awesome-cordova-plugins/mobile-accessibility/ngx';
import { Capacitor } from '@capacitor/core';
import { AlertController, IonRouterOutlet, Platform } from '@ionic/angular';
import { filter, switchMap } from 'rxjs/operators';
import { register } from 'swiper/element/bundle';
import { AppLogService } from './services/appLog.service';
import { AuthService } from './services/auth.service';
import { MaintenanceService } from './services/maintenance.service';
import { BrowserService } from './services/native/browser.service';
import { KeyboardService } from './services/native/keyboard.service';
import { NetworkService } from './services/network.service';
import { UserDataService } from './services/user/user-data.service';

registerLocaleData(localeEsAr, 'es-AR');
register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  tooltipVisibleName = false;
  internet = true;
  online = toSignal(this.networkService.isOnline(), { initialValue: true });
  @ViewChild(IonRouterOutlet, { static: true }) routerOutlet!: IonRouterOutlet;
  servicioactivo = true;
  menuactivo = false;
  intervalId: any;

  constructor(
    private platform: Platform,
    private router: Router,
    private networkService: NetworkService,
    private maintenanceService: MaintenanceService,
    private alertCtrl: AlertController,
    private mobileAccessibility: MobileAccessibility,
    private browserService: BrowserService,
    private keyboardService: KeyboardService,
    private userDataService: UserDataService,
    private injector: Injector,
    private authService: AuthService,
    private appLogService: AppLogService
  ) {
    runInInjectionContext(this.injector, () => {
      effect(
        () => {
          const activo = this.maintenanceService.isServicioActivo();
          this.servicioactivo = activo;
          if (!activo) {
            this.router.navigate(['/mantenimiento']);
          }
        },
        { allowSignalWrites: true }
      );

      effect(() => {
        this.internet = this.online();
        if (!this.online()) {
          this.router.navigate(['/no-internet']);
        }
      });
    });
  }
  ngOnInit() {
    // ✅ esto asegura un contexto válido
    runInInjectionContext(this.injector, () => {
      effect(
        () => {
          const activo = this.maintenanceService.isServicioActivo();
          this.servicioactivo = activo;
          if (!activo) {
            this.router.navigate(['/mantenimiento']);
          }
        },
        { allowSignalWrites: true }
      );
    });

    this.initializeApp();
  }

  async initializeApp() {
    await this.platform.ready();

    this.setupBackButton();
    this.setupAccessibility();
    this.setupFirstOpen();
    this.keyboardService.initService();

    this.authService
      .getloggedIn()
      .pipe(
        filter((isLoggedIn) => isLoggedIn?.length > 0),
        switchMap(() => this.userDataService.refreshUserProfilePhoto())
      )
      .subscribe();

    this.maintenanceService.checkForUpdates(this.platform);

    setTimeout(() => (this.menuactivo = true), 1500);
  }

  setupBackButton() {
    this.platform.backButton.subscribeWithPriority(-1, () => {
      if (!this.routerOutlet.canGoBack()) {
        window.navigator['app'].exitApp();
      }
    });
  }

  setupAccessibility() {
    if (Capacitor.isNativePlatform()) {
      this.mobileAccessibility.getTextZoom().then((zoom) => {
        if (zoom > 130) {
          this.mobileAccessibility.setTextZoom(130);
        }
      });

      if (this.platform.is('ios')) {
        this.routerOutlet.swipeGesture = false;
      }
    }
  }

  setupFirstOpen() {
    const firstOpenKey = 'app_first_open';
    if (!localStorage.getItem(firstOpenKey)) {
      this.appLogService.logEvent('ts_first_open');
      localStorage.setItem(firstOpenKey, 'true');
    }
  }

  observeNetwork() {
    this.networkService.isOnline().subscribe((online) => {
      this.internet = online;
      if (!online) {
        this.router.navigate(['/no-internet']);
      }
    });
  }

  ngOnDestroy() {
    this.maintenanceService.clear();
  }
}
